import React, { useRef } from "react";
import { AudioOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useSpeechRecognition } from "../context/recorderService";

export default function SpeechInput({
  value = "",
  onChange,
  placeholder = "",
  multiline = false,
  lang = "de-DE",
}) {
  const resizeTimeout = useRef(null);
  const { listening, interimValue, startListening, stopListening } = useSpeechRecognition({
    value,
    lang,
    onChange,
  });

  const handleResize = (el) => {
    if (!el) return;

    clearTimeout(resizeTimeout.current);

    resizeTimeout.current = setTimeout(() => {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }, 50);
  };

  const handleChange = (event) => {
    onChange && onChange(event.target.value);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
      <div style={{ flex: 1, position: "relative" }}>
        {multiline ? (
          <textarea
            className="speech-textarea"
            value={value}
            onChange={(event) => {
              handleChange(event);
              handleResize(event.target);
            }}
            placeholder={placeholder}
            ref={handleResize}
          />
        ) : (
          <input
            className="speech-input"
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
          />
        )}

        {interimValue && (
          <div
            style={{
              position: "absolute",
              left: 10,
              bottom: -20,
              fontSize: 14,
              color: "#999",
              pointerEvents: "none",
            }}
          >
            {interimValue}
          </div>
        )}
      </div>

      {!/iPad|iPhone|iPod/.test(window.navigator.userAgent) && (
        <Tooltip title="Zum Sprechen gedrückt halten">
          <Button
            onMouseDown={startListening}
            onMouseUp={stopListening}
            onMouseLeave={stopListening}
            onTouchStart={startListening}
            onTouchEnd={stopListening}
            className={`audio-btn audio-btn--record ${listening ? "is-active" : ""}`}
            icon={<AudioOutlined />}
            title="Zum Sprechen gedrückt halten"
          />
        </Tooltip>
      )}
    </div>
  );
}